import React from 'react';
import { Paper, Typography } from '@mui/material';

const DONUT_RADIUS = 35;
const DONUT_CIRCUMFERENCE = 2 * Math.PI * DONUT_RADIUS;

const DashboardDonutCard = ({ title, segments, total, classes }) => {
  let ratioCursor = 0;
  const safeTotal = total > 0 ? total : 1;

  const circles = segments.map((segment) => {
    const ratio = segment.value / safeTotal;
    const strokeLength = ratio * DONUT_CIRCUMFERENCE;
    const dashArray = `${strokeLength} ${DONUT_CIRCUMFERENCE}`;
    const dashOffset = -(ratioCursor * DONUT_CIRCUMFERENCE);
    ratioCursor += ratio;
    return { ...segment, dashArray, dashOffset };
  });

  return (
    <Paper elevation={0} className={classes.chartCard}>
      <Typography className={classes.cardTitle}>{title}</Typography>
      <div className={classes.donutWrap}>
        <div className={classes.donutSvgWrap}>
          <svg className={classes.donutSvg} width="96" height="96" viewBox="0 0 90 90">
            <circle cx="45" cy="45" r={DONUT_RADIUS} fill="none" stroke="#dce6f6" strokeWidth="12" />
            {circles.map((segment) => (
              <circle
                key={`donut-${segment.label}`}
                cx="45"
                cy="45"
                r={DONUT_RADIUS}
                fill="none"
                stroke={segment.color}
                strokeWidth="12"
                strokeDasharray={segment.dashArray}
                strokeDashoffset={segment.dashOffset}
              />
            ))}
          </svg>
          <div className={classes.donutCenter}>
            <div className={classes.donutTotal}>{total.toLocaleString('fr-FR')}</div>
            <div className={classes.donutSub}>marches</div>
          </div>
        </div>

        <div className={classes.donutLegend}>
          {segments.map((segment) => (
            <div key={`legend-${segment.label}`} className={classes.legendRow}>
              <span className={classes.legendDot} style={{ backgroundColor: segment.color }} />
              <span className={classes.legendLabel}>{segment.label}</span>
              <span className={classes.legendValue}>{segment.value.toLocaleString('fr-FR')}</span>
            </div>
          ))}
        </div>
      </div>
    </Paper>
  );
};

export default DashboardDonutCard;
